<template>
    <div class="field slider" :class="{ required: required }">
        <template v-if="label">
            <div class="heading">
                <label>{{ label }}</label>
            </div>
            <p class="value">{{ value }}</p>
        </template>
        <div class="input">
            <div ref="slider" class="slider" />
        </div>
        <p v-if="v && v.$error" class="error text--orange small semi">
            This field is required
        </p>
    </div>
</template>

<script>
import noUiSlider from "nouislider";

export default {
    props: {
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        value: {
            type: [Number, String],
            default: 1
        },
        range: {
            type: Object,
            default: () => ({
                min: 0,
                max: 100
            })
        },
        options: {
            type: [Array, Promise],
            default: () => []
        },
        sliderOptions: {
            type: Object,
            default: () => {}
        },
        v: {
            type: Object,
            default: null
        }
    },

    watch: {
        value(newValue) {
            this.$refs.slider.noUiSlider.updateOptions({
                start: newValue
            }, false);
        },

        range(newValue) {
            this.$refs.slider.noUiSlider.updateOptions({
                range: newValue,
            }, false);
        }
    },

    mounted() {
        noUiSlider.create(this.$refs.slider, {
            start: this.value,
            step: 1,
            range: {
                min: this.range.min,
                max: this.range.max
            },
            ...this.sliderOptions,
        });

        this.$refs.slider.noUiSlider.on('update', (values) => {
            this.$emit('input', parseInt(values[0]))
        });
    },

    destroy() {
        this.$refs.slider.noUiSlider.destroy();
    }
};
</script>

<style lang="scss" scoped>
    .slider {
        width: 100%;
    }

    .value {
        margin: 0.75em 0;
        color: #FFF;
    }

    .error {
        margin-top: 0.5em;
    }

    .noUi-target {
        height: 1px;
        background-color: rgba(#FFF, 0.5);

        .noUi-handle {
            top: -14px !important;
        }
    }

</style>

<style lang="scss">
    .field.slider .noUi-target {
        height: 1px;
        background-color: rgba(#FFF, 0.5);

        .noUi-handle {
            top: -14px !important;
        }

        .noUi-tooltip {
            bottom: auto;
            top: 120%;
            background: transparent;
            border: none;
            color: #FFF;
            font-weight: 500;
        }
    }
</style>
